import http from '@/http/aisea/axios'
const resource = "/enterprise/vessels/";

export default {
  fetch(vesselId) {
    return http.get(`${resource}${vesselId}/documents/search`);
  },

  fetchEnterpriseVesselDocuments(vesselId, params) {
    return http.get(`${resource}${vesselId}/documents/search`, {
      params: params});
  },

  update(vesselId, linkId, payload) {
    return http.put(`${resource}${vesselId}/documents/${linkId}`, payload);
  },

  add(vesselId, payload) {
    return http.post(`${resource}${vesselId}/documents`, payload);
  },

  delete(vesselId, linkId) {
    return http.delete(`${resource}${vesselId}/documents/${linkId}`);
  },

};
